import { ReduxActionType, MapPlaceSuggestion } from 'types';

export interface ActionTypes {
  FETCH_USER_START: ReduxActionType;
  FETCH_USER_SUCCESS: ReduxActionType;
  FETCH_USER_FAILURE: ReduxActionType;
  SIGN_OUT: ReduxActionType;
  FETCH_USER_SEARCH_START: any;
  FETCH_USER_SEARCH_SUCCESS: ReduxActionType;
  FETCH_USER_SEARCH_FAILURE: ReduxActionType;

  FETCH_APIKEYS_START: ReduxActionType;
  FETCH_APIKEYS_SUCCESS: ReduxActionType;
  FETCH_APIKEYS_FAILURE: ReduxActionType;

  ADD_APIKEYS_START: ReduxActionType;
  ADD_APIKEYS_SUCCESS: ReduxActionType;
  ADD_APIKEYS_FAILURE: ReduxActionType;

  DELETE_APIKEYS_START: ReduxActionType;
  DELETE_APIKEYS_FAILURE: ReduxActionType;

  UPDATE_USER_START: ReduxActionType;
  UPDATE_USER_SUCCESS: ReduxActionType;
  UPDATE_USER_FAILURE: ReduxActionType;

  PROFILE_UPDATING_FLAG: ReduxActionType;

  CONTACT_SUPPORT_FLAG: ReduxActionType;

  CONTACT_SUPPORT_START: ReduxActionType;
  CONTACT_SUPPORT_SUCCESS: ReduxActionType;
  CONTACT_SUPPORT_FAILURE: ReduxActionType;
  CONTACT_SUPPORT_CLEAR: ReduxActionType;
  UPDATE_USER_DONE: ReduxActionType;

  GET_ADDRESS_SEARCH_SUGGESTION_START: ReduxActionType;
  GET_ADDRESS_SEARCH_SUGGESTION_SUCCESS: ReduxActionType;
  GET_ADDRESS_SEARCH_SUGGESTION_FAILURE: ReduxActionType;
  CLEAR_ADDRESS_SEARCH_SUGGESTION: ReduxActionType;
  SHOW_NOTIFICATION_OPTIONS_MODAL: ReduxActionType;

  // Temporary block - need to delete after Helix enabled
  FETCH_REMEDY_FORCE_USER_START: ReduxActionType;
  FETCH_REMEDY_FORCE_USER_SUCCESS: ReduxActionType;
  FETCH_REMEDY_FORCE_USER_FAILURE: ReduxActionType;
  // Temporary block
}

export const UserActionTypes: ActionTypes = {
  FETCH_USER_START: '@@FETCH_USER_START',
  FETCH_USER_SUCCESS: '@@FETCH_USER_SUCCESS',
  FETCH_USER_FAILURE: '@@FETCH_USER_FAILURE',
  SIGN_OUT: '@@SET_USER_SIGN_OUT',

  FETCH_USER_SEARCH_START: '@@FETCH_USER_SEARCH_START',
  FETCH_USER_SEARCH_SUCCESS: '@@FETCH_USER_SEARCH_SUCCESS',
  FETCH_USER_SEARCH_FAILURE: '@@FETCH_USER_SEARCH_FAILURE',

  FETCH_APIKEYS_START: '@@FETCH_APIKEYS_START',
  FETCH_APIKEYS_SUCCESS: '@@FETCH_APIKEYS_SUCCESS',
  FETCH_APIKEYS_FAILURE: '@@FETCH_APIKEYS_FAILURE',

  ADD_APIKEYS_START: '@@ADD_APIKEYS_START',
  ADD_APIKEYS_FAILURE: '@@ADD_APIKEYS_FAILURE',
  ADD_APIKEYS_SUCCESS: '@@ADD_APIKEYS_SUCCESS',

  DELETE_APIKEYS_START: '@@DELETE_APIKEYS_START',
  DELETE_APIKEYS_FAILURE: '@@DELETE_APIKEYS_FAILURE',

  UPDATE_USER_START: '@@UPDATE_USER_START',
  UPDATE_USER_SUCCESS: '@@UPDATE_USER_SUCCESS',
  UPDATE_USER_DONE: '@@UPDATE_USER_DONE',
  UPDATE_USER_FAILURE: '@@UPDATE_USER_FAILURE',

  PROFILE_UPDATING_FLAG: '@@PROFILE_UPDATING_FLAG',

  CONTACT_SUPPORT_FLAG: '@@CONTACT_SUPPORT_FLAG',

  CONTACT_SUPPORT_START: '@@CONTACT_SUPPORT_START',
  CONTACT_SUPPORT_SUCCESS: '@@CONTACT_SUPPORT_SUCCESS',
  CONTACT_SUPPORT_FAILURE: '@@CONTACT_SUPPORT_FAILURE',
  CONTACT_SUPPORT_CLEAR: '@@CONTACT_SUPPORT_CLEAR',

  // Temporary block - need to delete after Helix enabled
  FETCH_REMEDY_FORCE_USER_START: '@@FETCH_REMEDY_FORCE_USER_START',
  FETCH_REMEDY_FORCE_USER_SUCCESS: '@@FETCH_REMEDY_FORCE_USER_SUCCESS',
  FETCH_REMEDY_FORCE_USER_FAILURE: '@@FETCH_REMEDY_FORCE_USER_FAILURE',
  // Temporary block

  GET_ADDRESS_SEARCH_SUGGESTION_START: '@@GET_ADDRESS_SEARCH_SUGGESTION_START',
  GET_ADDRESS_SEARCH_SUGGESTION_SUCCESS:
    '@@GET_ADDRESS_SEARCH_SUGGESTION_SUCCESS',
  GET_ADDRESS_SEARCH_SUGGESTION_FAILURE:
    '@@GET_ADDRESS_SEARCH_SUGGESTION_FAILURE',
  CLEAR_ADDRESS_SEARCH_SUGGESTION: '@@CLEAR_ADDRESS_SEARCH_SUGGESTION',
  SHOW_NOTIFICATION_OPTIONS_MODAL: '@@SHOW_NOTIFICATION_OPTIONS_MODAL'
};

export interface ApiKey {
  clientId: string;
  lastUsedAt: string;
  id: string;
  createdAt: string;
}
export interface UserState {
  loading: boolean;
  error?: string | undefined;
  user?: Object;
  apiKeys: Array<ApiKey> | null;
  users?: Object[];
  profileUpdatingFlag?: boolean;
  contactSupportFlag?: boolean;
  contctSupportError?: boolean;
  supportReqSubmitting?: boolean;
  supportRes?: any;
  updatingUser?: boolean;
  addressSearchSuggestion?: MapPlaceSuggestion[] | string;
  showNotificationOptionsModal?: boolean;
  // Temporary block - need to delete after Helix enabled
  remedyForceClient?: boolean;
  // Temporary block
}

export interface UserSearchParams {
  searchBy: string;
  search: string;
}

export interface UsersState {
  firstName: string;
  lastName: string;
  role: string;
  email: string;
}

export interface Timezone {
  code: string;
  label: string;
}
